import Alert from './src/alert-combined';
export default Alert;